var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"font-semibold leading-4 text-xs rounded-sm px-1 whitespace-no-wrap generic-medication-tag"},[_vm._v(_vm._s(_vm.$t("GenericMedicationTag.Message")))])}
var staticRenderFns = []

export { render, staticRenderFns }